export const CRegexPatterns: { [key: string]: RegExp } = {
  systemPrefix: /^\[Hệ thống\] /
}
